export default {
	authorize (requiredRoles) {
		let token = window.localStorage.getItem('token') || undefined
		let user = JSON.parse(window.localStorage.getItem('user')) || undefined
		if (token !== undefined && user !== undefined) {
			if (requiredRoles === undefined) {
				return true
			} else {
				for (var i = 0; i < user.roles.length; i++) {
					if (requiredRoles.includes(user.roles[i])) {
						return true
					}
				}
			}
		}
		return false
	}
}



// WEBPACK FOOTER //
// ./src/authorization/Authorization.js